import { createContext, type JSX, useContext } from 'solid-js'
import { MainModule } from '../../../features/main-module'
import { type GetInboxMessagesInteractor } from '../../../features/moderation/domain/interactors/get-inbox-messages.interactor'
import { type GetReviewedMessagesInteractor } from '../../../features/moderation/domain/interactors/get-reviewed-messages.interactor'
import { type ApplyActionInteractor } from '../../../features/moderation/domain/interactors/apply-action.interactor'
import { type GetFlaggingRulesInteractor } from '../../../features/moderation/domain/interactors/get-flagging-rules.interactor'
import { type SSEOptions } from '../../primitives/createSSE'

interface ModerationContextType {
  getInboxMessages: GetInboxMessagesInteractor
  getReviewedMessages: GetReviewedMessagesInteractor
  applyAction: ApplyActionInteractor
  getFlaggingRules: GetFlaggingRulesInteractor
  getSSEOptions: (onMessage: () => void) => Promise<SSEOptions>
}

const CorisModerationContext = createContext<ModerationContextType>()

export const CorisModerationProvider = (props: { children: JSX.Element }): JSX.Element => {
  const moderationComponent = MainModule.getModerationComponent()

  const value: ModerationContextType = {
    getInboxMessages: moderationComponent.provideGetInboxMessages(),
    getReviewedMessages: moderationComponent.provideGetReviewedMessages(),
    applyAction: moderationComponent.provideApplyAction(),
    getFlaggingRules: moderationComponent.provideGetFlaggingRules(),
    getSSEOptions: (onMessage) => moderationComponent.getSSEOptions(onMessage)
  }

  return <CorisModerationContext.Provider value={value}>{props.children}</CorisModerationContext.Provider>
}

export const useCorisModeration = (): ModerationContextType => {
  const context = useContext(CorisModerationContext)
  if (!context) {
    throw new Error('useCorisModeration must be used inside a CorisModerationProvider')
  }
  return context
}
